// import { createSelector } from 'reselect';

import { __getCommonData } from '../../selectors';
// import { getValueOfCookie } from '../settings/selectors';

/** Base Data selector, all the other selectors must use it */
const getNotifySettings = (state) => __getCommonData(state).notify || {};

export const getUseNotificationState = (state) => getNotifySettings(state).useNotification;
export const getNotificationDefaultOpenState = (state) => getNotifySettings(state).isOpen;

export const getNotificationType = (state) => getNotifySettings(state).notificationType;

export const getNotificationContent = (state) => getNotifySettings(state).notificationContent || [];
export const getNotificationHasContent = (state) => getNotificationContent(state).length !== 0;
